import React from 'react'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import TableRelatorios from '../../components/Table/TableRelatorios';
import TableTrilhaDn from '../../components/Table/TableTrilhaDn';
import LegendaReport from '../../components/LegendaReport';
import TableEssayGrades from '../../components/Table/TableEssayGrades';

function basicBarChart({ data, title, legend = true }) {
  const options = {
    chart: {
      type: 'column',
    },
    title: {
      text: title,
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
    legend: { 
      enabled: legend,
    },
    xAxis: {
      categories: data.categories ? data.categories : '',
      crosshair: true,
    },
    yAxis: {
      title: {
        text: 'Nota Redação',
      },
    },
    series: data.series ? data.series : '',
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}

export default basicBarChart;